import { useState, useRef, useCallback } from 'react'

const useInfiniteScroll = (
  root: Element | null = null,
  rootMargin?: string
) => {
  const [touchBottom, setTouchBottom] = useState(false)
  const observerRef = useRef<IntersectionObserver | null>(null)

  const handleObserver = useCallback((entries: IntersectionObserverEntry[]) => {
    setTouchBottom(entries[0].isIntersecting)
  }, [])

  // 回调 ref，每次节点变动就会触发
  const loadMoreRef = useCallback(
    (node: Element | null) => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
      if (node) {
        observerRef.current = new IntersectionObserver(handleObserver, {
          root,
          rootMargin,
        })
        observerRef.current.observe(node)
      }
    },
    [handleObserver, root, rootMargin]
  )

  return { loadMoreRef, touchBottom }
}

export default useInfiniteScroll
